module.exports = __webpack_public_path__ + "static/cosmicguard.com/img/cosmic_games_logo.720cf68e.png";